import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";
import SVGComponent from "./SVGComponent";
import { strokeDashTypes } from "../utils";
import {
  extractThresholdValue,
  extractThresholdLine,
  clipToBand,
  clipOutsideBand,
  bandClipRects,
} from "./oscillatorThresholds";

class CCISeries extends Component {
  constructor(props) {
    super(props);
    this.renderClip = this.renderClip.bind(this);
    this.topAndBottomClip = this.topAndBottomClip.bind(this);
    this.mainClip = this.mainClip.bind(this);

    const id1 = String(Math.round(Math.random() * 10000 * 10000));
    this.clipPathId1 = `cci-clip-${id1}`;

    const id2 = String(Math.round(Math.random() * 10000 * 10000));
    this.clipPathId2 = `cci-clip-${id2}`;
  }

  topAndBottomClip(ctx, moreProps) {
    const { overSold, overBought } = this.props;
    clipToBand(
      ctx,
      moreProps,
      extractThresholdValue(overBought, 100),
      extractThresholdValue(overSold, -100),
    );
  }

  mainClip(ctx, moreProps) {
    const { overSold, overBought } = this.props;
    clipOutsideBand(
      ctx,
      moreProps,
      extractThresholdValue(overBought, 100),
      extractThresholdValue(overSold, -100),
    );
  }

  renderClip(moreProps) {
    const { overSold, overBought } = this.props;
    const { overBoughtY, overSoldY, width, height } = bandClipRects(
      moreProps,
      extractThresholdValue(overBought, 100),
      extractThresholdValue(overSold, -100),
    );

    return (
      <defs>
        <clipPath id={this.clipPathId1}>
          <rect
            x={0}
            y={overBoughtY}
            width={width}
            height={overSoldY - overBoughtY}
          />
        </clipPath>
        <clipPath id={this.clipPathId2}>
          <rect x={0} y={0} width={width} height={overBoughtY} />
          <rect x={0} y={overSoldY} width={width} height={height - overSoldY} />
        </clipPath>
      </defs>
    );
  }

  render() {
    const {
      className,
      yAccessor,
      stroke,
      overSold,
      overBought,
      onContextMenu,
    } = this.props;

    const overBoughtData = extractThresholdLine(overBought, 100, {
      color: "#B8C2CC",
      dash: "Dash",
      width: 1,
      opacity: 1,
    });
    const overSoldData = extractThresholdLine(overSold, -100, {
      color: "#B8C2CC",
      dash: "Dash",
      width: 1,
      opacity: 1,
    });

    // Handle both simple stroke object and complex stroke structure for main CCI line
    // If stroke is a simple object (from form), use it directly
    const cciStroke = stroke.line ? stroke.line : stroke;

    const style1 = { clipPath: `url(#${this.clipPathId1})` };
    const style2 = { clipPath: `url(#${this.clipPathId2})` };

    return (
      <g className={className}>
        <SVGComponent>{this.renderClip}</SVGComponent>
        <StraightLine
          stroke={overSoldData.stroke}
          yValue={overSoldData.value}
          onContextMenu={onContextMenu}
        />
        <StraightLine
          stroke={overBoughtData.stroke}
          yValue={overBoughtData.value}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          style={style1}
          canvasClip={this.topAndBottomClip}
          className={className}
          yAccessor={yAccessor}
          stroke={cciStroke}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          style={style2}
          canvasClip={this.mainClip}
          className={className}
          yAccessor={yAccessor}
          stroke={cciStroke}
          onContextMenu={onContextMenu}
        />
      </g>
    );
  }
}

CCISeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.oneOfType([
    // Simple stroke object (from form)
    PropTypes.shape({
      color: PropTypes.string,
      opacity: PropTypes.number,
      width: PropTypes.number,
      dash: PropTypes.oneOf(strokeDashTypes),
    }),
    // Complex stroke structure (backwards compatibility)
    PropTypes.shape({
      line: PropTypes.shape({
        color: PropTypes.string,
        opacity: PropTypes.number,
        width: PropTypes.number,
        dash: PropTypes.oneOf(strokeDashTypes),
      }),
    }),
  ]).isRequired,
  overBought: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      value: PropTypes.number,
      stroke: PropTypes.shape({
        color: PropTypes.string,
        opacity: PropTypes.number,
        width: PropTypes.number,
        dash: PropTypes.oneOf(strokeDashTypes),
      }),
    }),
  ]),
  overSold: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      value: PropTypes.number,
      stroke: PropTypes.shape({
        color: PropTypes.string,
        opacity: PropTypes.number,
        width: PropTypes.number,
        dash: PropTypes.oneOf(strokeDashTypes),
      }),
    }),
  ]),
  onContextMenu: PropTypes.func,
};

CCISeries.defaultProps = {
  className: "cci-series",
};

export default CCISeries;
